// extracted by mini-css-extract-plugin
module.exports = {"buttonText":"Group_buttonText__2fA9b","buttonIcon":"Group_buttonIcon__3BYYF"};